import { useMemo } from 'react';
import type { TFunction } from 'i18next';
import { EvseType } from '@evimo/types/enums/evse-type';

export function useAssetStandardOptions(
  t: TFunction<'assets'>,
): Array<{ value: EvseType; label: string }> {
  return useMemo(
    () => [
      { value: EvseType.AC, label: t('standard.options.AC', 'AC') },
      { value: EvseType.DC, label: t('standard.options.DC', 'DC') },
      {
        value: EvseType.AC_DC,
        label: t('standard.options.AC_DC', 'AC/DC'),
      },
    ],
    [t],
  );
}
